module.exports = __webpack_public_path__ + "static/media/crisk.c22992e2.png";